import { Component, OnDestroy, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpEventType } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import * as fromRoot from '../../../store/reducers';
import { TestTakerActions, AppUiActions } from '../../../store/actions';
import { MyModal } from '../../common/my-modal/my-modal.component';
import * as Enum from '../../../dtos/enums';
import { AuthService } from '../../../services/auth.service';
import { TestContentService } from '../../../services/test-content.service';
import { TestTakerService } from '../../../services/test-taker.service';
import { HttpResponse } from '@angular/common/http';
import { ConfigHelper } from 'app/services/config.helper';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'start-screen-pending',
    template: require('./start-screen-pending.component.html')
})
export class StartScreenPendingComponent implements OnDestroy, OnInit {
    private routeParamsSubscription: Subscription;
    private readonly defaultMessage = "Waiting for station assignment.";
    stationNumber: number;
    testTakerPhotoUrl: string;
    errorMsg: string;
    message: string = this.defaultMessage;
    testTakerInfo: PgRendererDto.TestTakerStationAssignment = {} as any;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private testTakerService: TestTakerService,
        private testContentService: TestContentService,
        private store: Store<fromRoot.State>,
        private myModal: MyModal,
        private authService: AuthService
    ) {
    }

    pollForTestTakerInfo() {
        Observable.interval(10000)
            .startWith(1)
            .flatMap(x => this.testTakerService.getStationAssignment(this.stationNumber))
            .filter(x => x != null)
            .take(1)
            .retryWhen(errors => errors.delay(60000))
            .subscribe(testTakerInfo => {
                this.onStationAssignmentReceived(testTakerInfo);
            });
    }

    ngOnInit() {
        this.testTakerPhotoUrl = this.testTakerService.getBlankTestTakerPhotoUrl();
        this.routeParamsSubscription = this.route.params.subscribe(params => {
            if (params) {
                const stationNumber = params['station-number'];
                this.stationNumber = stationNumber;
                this.pollForTestTakerInfo();
            }
        });
    }

    ngOnDestroy() {
        this.routeParamsSubscription.unsubscribe();
    }

    onStationAssignmentReceived(testTakerInfo: PgRendererDto.TestTakerStationAssignment) {
        if (_paragonConfig.useLocalTestContentServer) {
            this.message = "Downloading...";
            this.testContentService.downloadTestContentFile(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.StationNumber).subscribe(
                success => {
                    this.showStationAssignment(testTakerInfo);
                },
                error => {
                    this.message = this.defaultMessage;
                    this.myModal.showRegularDlg("Error", error);
                }
            );
        } else {
            this.showStationAssignment(testTakerInfo);
        }
    }

    showStationAssignment(testTakerInfo: PgRendererDto.TestTakerStationAssignment) {
        this.testTakerInfo = testTakerInfo;
        this.store.dispatch(new TestTakerActions.SetTestTakerInfo(testTakerInfo));
        ConfigHelper.setTestTypeId(testTakerInfo.TestTypeId);
        this.testTakerPhotoUrl = this.testTakerService.getTestTakerPhotoUrl(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.TestTakerId);
        this.router.navigate([`start-screen/${testTakerInfo.StationNumber}/pin`]);
    }

    clearErrorMsg() {
        this.errorMsg = "";
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-pending.component.ts